(() => {
  const update = (form) => {
    const fields = form?.querySelector('[data-gift-card-recipient-fields]');
    const contract = form?.querySelector('[data-gift-card-recipient-contract]');
    if (!fields) return;
    const gifting = form.querySelector('[data-gift-card-recipient-toggle]')?.checked === true;
    fields.hidden = !gifting;
    if (contract) contract.disabled = !gifting;
    fields.querySelectorAll('input, textarea').forEach((field) => { field.disabled = !gifting; });
  };
  document.querySelectorAll('[data-gift-card-recipient-form]').forEach(update);
  document.addEventListener('change', (event) => {
    const mode = event.target.closest('[data-gift-card-recipient-mode]');
    if (mode) update(mode.closest('[data-gift-card-recipient-form]'));
  });
})();
